export type { AppDialogConfig } from '../../services/app-dialog.service';
export { AppDialogRef } from '../../services/app-dialog.service';
export { AppDialogService } from '../../services/app-dialog.service';
export type { AppDialogSize } from '../../services/app-dialog.service';
